import auth from './auth.slice';
import loading from './loading.slice';
import compact from './compact.slice';
import modal from './modal.slice';
import serviceagreements from './serviceagreements.slice';
import applicationdropdown from './productcostapplication.slice';
import seedsdropdown from './productcostseeds.slice';
import cropyeardropdown from './cropyear.slice';
import user from './user.slice';
import billingEntity from './billingInvoices.slice';
import addfarm from './addfarm-billingentity.slice';
import revenueSlice from './revenue.slice'
import contractPrice from './contractprice.slice'
import harvestdetail from "./harvestdetail.slice"
import inventorymanagement from "./inventorymanagement.slice"
import addCost from "./addCost.slice"

export const reducer = {
  loading,
  auth,
  modal,
  compact,
  serviceagreements,
  billingEntity,
  revenue: revenueSlice,
  contractPrice,
  harvestdetail,
  inventorymanagement,
  applicationdropdown,
  seedsdropdown,
  cropyeardropdown,
  user,
  addfarm,
  addCost
};
